import {
  dateOperating
} from '@/cllib/tools'

import {
  distributionGetData
} from '@/api/api'

const state = {
  distributionLossData: [],
  distributionLossSearchParm: {
    date: [],
    companyIds: null,
    carGroupIds: null,
    groupIds: null
  },
  distributionLossDataLoading: false,
  minDistributionLossProportion: 0.0014
}

const getters = {
  distributionLossData: state => state.distributionLossData,
  distributionLossSearchParm: state => state.distributionLossSearchParm,
  distributionLossDataLoading: state => state.distributionLossDataLoading,
  minDistributionLossProportion: state => state.minDistributionLossProportion
}

const actions = {
  loadDistributionLossData ({ dispatch, getters }) {
    dispatch('setDistributionLossDataLoading', true)
    let parm = {
      noPage: 1,
      isMerge: 0,
      status: 'end',
      groupIds: getters.distributionLossSearchParm.groupIds || null,
      companyIds: getters.distributionLossSearchParm.companyIds || null,
      carGroupIds: getters.distributionLossSearchParm.carGroupIds || null,
      planTime: dateOperating.formatDate({date: getters.distributionLossSearchParm.date[0], format: 'yy-mm-dd'}),
      endTime: dateOperating.computeDay({days: 1, date: getters.distributionLossSearchParm.date[1], format: 'yy-mm-dd'})
    }
    return distributionGetData(parm).then((data) => {
      let newData = []
      data.forEach((item) => {
        item.planTimeS = item.planTime ? item.planTime.slice(5, 10) : ''
        item.sendTime = item.sendTime ? item.sendTime.slice(5, 16) : ''
        item.inTime = item.inTime ? item.inTime.slice(5, 16) : ''
        item.oilNameS = item.oilName.split('号')[0] + '#'
        item.lossVolume = Number((item.loadVolume - item.inVolume).toFixed(0))
        item.lossProp = (item.lossVolume / item.loadVolume).toFixed(4)
        if (item.lossProp > getters.minDistributionLossProportion) {
          newData.push(item)
        }
      })
      dispatch('setDistributionLossData', newData)
      dispatch('setDistributionLossDataLoading', false)
    }).catch((e) => {
      dispatch('setDistributionLossDataLoading', false)
    })
  },
  setDistributionLossData ({ commit }, data) {
    commit('setDistributionLossData', data)
  },
  setMinDistributionLossProportion ({ commit }, data) {
    commit('setMinDistributionLossProportion', data)
  },
  setDistributionLossDataLoading ({ commit }, data) {
    commit('setDistributionLossDataLoading', data)
  },
  setDistributionLossSearchParm ({ commit }, data) {
    commit('setDistributionLossSearchParm', data)
  },
  updateDistributionLossSearchParm ({ commit }, data) {
    commit('updateDistributionLossSearchParm', data)
  }
}

const mutations = {
  setMinDistributionLossProportion (state, data) {
    state.minDistributionLossProportion = data
  },
  setDistributionLossData (state, data) {
    state.distributionLossData = data
  },
  setDistributionLossDataLoading (state, data) {
    state.distributionLossDataLoading = data
  },
  setDistributionLossSearchParm (state, data) {
    state.distributionLossSearchParm = data
  },
  updateDistributionLossSearchParm (state, {key, data}) {
    state.distributionLossSearchParm[key] = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/loss_system/distribution_loss/distribution_loss_data.js